export default __webpack_public_path__ + "static/media/ic_btc.b_24.bab8cadc.svg";